module.exports = __webpack_public_path__ + "img/ic_failed_unread.d8ddce8d.svg";